<template>
    <portlet
            :icon="'fad fa-file-certificate'"
            :title="'Certificaten'"
    >
        <template slot="portletBody">
            <form v-if="Can(rights.CERTIFICATE_ADD)" @submit.prevent="addCertificate()">
                <div class="row align-items-end mb-5">
                    <div class="col-sm-8 col-lg-10">
                        <label for="certificate-name">Voeg een certificaat toe</label>
                        <input required
                               name="certificate-name"
                               id="certificate-name"
                               type="text"
                               class="form-control"
                               v-model="name">
                    </div>
                    <div class="col-sm-4 col-lg-2 certificate-save">
                        <button class="btn btn-primary btn-block">
                            Toevoegen
                        </button>
                    </div>
                </div>
            </form>

            <datatables
                    :tableClass="tableClass"
                    v-if="getAllCertificates.length && renderedComponent && Can(rights.CERTIFICATE_VIEW)"
                    :rows="getAllCertificates"
                    :columns="columns"
                    tableID="certificates"
                    :tableInitOptions="tableInitOptions"
                    routerLinkClass="dt-router-link"
                    :deleteFunction="deleteCertificate"
                    deleteClass="delete"
                    :getDataClass="'get-data'"
                    @rowSelected="rowSelected"
            ></datatables>

            <edit-name-default
                    v-if="certificate"
                    :title="'Certificaat aanpassen'"
                    :value="certificate"
                    :name="modalId"
                    @saveChanges="editCertificate($event)"
            ></edit-name-default>

        </template>
    </portlet>
</template>

<script>
    import {mapGetters} from 'vuex'
    import editNameDefault from '../../components/editNameDefault'
    import {dataTables} from "../../components/mixins/dataTables";
    import {swalModals} from "../../components/mixins/swalModals.js";
    import { Can } from '../../../permission/ability.js';
    import { RIGHTS } from '../roles/rights.js';

    export default {
        mixins: [dataTables, swalModals],
        components: {editNameDefault},
        data() {
            return {
                name: '',
                certificate: null,
                rights: '',
                tableInitOptions: {
                    order: [[1, "desc"]],
                },
                columns: [
                    {data: 'name', name: 'Naam', visible: true, searchable: true, responsivePriority: 1},
                    {
                        data: 'standard', name: 'Standaard', visible: true, searchable: true,
                        render(data) {
                            return (data ? '<i class="fas fa-check"></i>' : '');
                        }
                    },
                    {
                        data: null, name: 'Opties', orderable: false, responsivePriority: 2,
                        render(data) {
                            var options = '';

                            if(Can(RIGHTS.CERTIFICATE_EDIT)) {
                                options += '<i title="Certificaat aanpassen" class="far fa-edit action-icon get-data" data-target="#' + data.id + '" data-toggle="modal"></i>';                                
                            }

                            if(Can(RIGHTS.CERTIFICATE_DELETE)) {
                                options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
                            }

                            return options;
                        }
                    },
                ],
            }
        },
        methods: {
            Can,
            rowSelected(value) {
                this.modalId = value.id;
                this.certificate = {id: this.modalId, name: value.name, standard: value.standard};
            },
            addCertificate() {
                this.$store.dispatch('certificates/set', {name: this.name, standard: true, department: this.$store.getters.getUserData.selectedDepartment}).then(() => {
                    this.$toasted.global.successRequest({
                        message: 'Certificaat aangemaakt',
                    });
                    this.name = '';

                    this.renderComponent();
                }).catch(() => {
                    this.$toasted.global.failedRequest();
                })
            },
            editCertificate(certificate) {
                if (certificate.name) {
                    let id = certificate.id;

                    $('.modal').modal('hide');
                    $('.modal-backdrop').remove();

                    this.$toasted.global.successRequest({
                        message: 'Certificaat aangepast',
                    });
                    this.$store.dispatch('certificates/set', {
                        id,
                        name: certificate.name,
                        standard: certificate.standard
                    });

                    this.renderComponent();
                }
            },
            deleteCertificate(certificate) {
                let id = certificate.id;
                this.swalDelete(certificate.name).then(result => {
                    if (result.value) {
                        this.$store.dispatch('certificates/delete', id);

                        this.$toasted.global.successRequest({
                            message: 'Certificaat verwijderd',
                        });

                        this.renderComponent();
                    }
                })
            },
        },
        computed: {
            ...mapGetters('certificates', [
                    'getAllCertificates',
                ]
            ),
        },
        created() {
            this.rights = RIGHTS;
        }
    };
</script>
